export default __webpack_public_path__ + "/src/assets/images/bck_env_program_row_odd.png";